import validator from 'validator';
import * as yup from 'yup';

declare module 'yup' {
  interface StringSchema {
    emailValidation(message?: string): StringSchema;
    notContainsName(): StringSchema;
    notInDictionary(dictionary: Set<string>, message: string): StringSchema;
  }
}

export const emailIsInvalid = 'Email is invalid';
yup.addMethod(yup.string, 'emailValidation', function (message?: string) {
  return this.test('emailValidator', message ?? emailIsInvalid, value => {
    return value && validator.isEmail(value);
  });
});

yup.addMethod(yup.string, 'notContainsName', function () {
  return this.test(
    'notContainsName',
    'Your password must not contain your first name or last name.',
    function (value: string | undefined) {
      if (!value) {
        return true;
      }
      const names: string[] = [];
      this.parent.firstName && names.push(this.parent.firstName);
      this.parent.lastName && names.push(this.parent.lastName);

      if (names.length === 0) {
        return true;
      }

      const pattern = names.join('|');
      const index = value.search(new RegExp(pattern, 'i'));
      return index === -1;
    },
  );
});

yup.addMethod(yup.string, 'notInDictionary', function (dictionary: Set<string>, message: string) {
  return this.test('notInDictionary', message, function (value) {
    return !value || !dictionary.has(value?.toLowerCase());
  });
});

export default yup;
